import EmblaCarousel from "embla-carousel";
import Swiper from "swiper";
import { Navigation, Pagination, Keyboard, Autoplay } from "swiper/modules";

// Resize height
function glideHandleHeight(id) {
  let currentSlider = ".slider-" + id;
  let glideTrackHeight = document.querySelector(
    currentSlider + " .glide__track"
  );
  let glideSlide = document.querySelectorAll(
    currentSlider + " .glide__slide--active img"
  );
  let i;
  for (i = 0; i < glideSlide.length; i++) {
    glideTrackHeight.style.height = glideSlide[i].offsetHeight + "px";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var emblaNode = document.getElementById("grundEmbla");
  if (emblaNode) {
    var viewport = emblaNode.querySelector(".embla__viewport");
    var embla = EmblaCarousel(viewport, {
      loop: false,
      slidesToScroll: 1,
      dragFree: false,
      breakpoints: {
        "(max-width: 1024px)": { slidesToScroll: 1 },
      },
    });

    const dotsNode = emblaNode.querySelector(".embla__dots");
    if (dotsNode) {
      // Create dot buttons
      const slideCount = emblaNode.querySelectorAll(".embla__slide").length;
      const dots = Array.from({ length: slideCount }, (_, i) => {
        const dot = document.createElement("button");
        dot.className = "embla__dot";
        dot.innerHTML = `<span class="sr-only">Go to slide ${i + 1}</span>`;
        dotsNode.appendChild(dot);
        return dot;
      });

      // Update dots on scroll
      const updateDots = () => {
        const selectedIndex = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          dot.classList.toggle("is-selected", index === selectedIndex);
        });
      };

      // Initialize dots
      updateDots();
      embla.on("select", updateDots);

      // Add click handlers
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          embla.scrollTo(index);
        });
      });
    }
  }

  const emblaNodeRelatedEntities = document.getElementById(
    "relatedEntitiesEmbla"
  );
  if (emblaNodeRelatedEntities) {
    const viewport = emblaNodeRelatedEntities.querySelector(".embla__viewport");
    const emblaRelatedEntities = EmblaCarousel(viewport, {
      align: "start",
      loop: false,
      slidesToScroll: 1,
      dragFree: false,
      breakpoints: {
        "(max-width: 1024px)": { slidesToScroll: 1 },
      },
    });

    console.log("embla relatedEntitiesEmbla", emblaRelatedEntities);

    // Navigation
    var prevBtn = document.querySelector(".embla-prev.entities");
    var nextBtn = document.querySelector(".embla-next.entities");
    console.log("prevBtn", prevBtn);
    console.log("nextBtn", nextBtn);
    nextBtn.addEventListener("click", function () {
      console.log("nextBtn clicked");
      emblaRelatedEntities.scrollNext();
    });
    prevBtn.addEventListener("click", function () {
      console.log("prevBtn clicked");
      emblaRelatedEntities.scrollPrev();
    });
  }
});

window.addEventListener("load", function () {
  const swiperNode = document.querySelectorAll(".swiper");
  if (swiperNode.length > 0) {
    swiperNode.forEach((swiper) => {
      const swiperOptions = {
        modules: [Navigation, Pagination, Keyboard, Autoplay],
        slidesPerView: swiper.dataset.slidesperviewresp
          ? swiper.dataset.slidesperviewresp
          : 1.1,
        spaceBetween: swiper.dataset.spacebetweenresp
          ? swiper.dataset.spacebetweenresp
          : swiper.dataset.spacebetween
          ? swiper.dataset.spacebetween
          : 30,
        pagination: {
          el: swiper.dataset.pagination
            ? document.querySelector(swiper.dataset.pagination)
            : document.querySelector(".swiper-pagination"),
          clickable: swiper.dataset.clickable ? swiper.dataset.clickable : true,
        },
        navigation: {
          prevEl: swiper.dataset.prevel
            ? swiper.dataset.prevel
            : ".swiper-button-prev",
          nextEl: swiper.dataset.nextel
            ? swiper.dataset.nextel
            : ".swiper-button-next",
        },
        keyboard: {
          enabled: swiper.dataset.keyboard ? swiper.dataset.keyboard : true,
        },
        breakpoints: {
          767: {
            slidesPerView: 2.1,
            spaceBetween: swiper.dataset.spacebetween
              ? swiper.dataset.spacebetween
              : 20,
          },
          1024: {
            slidesPerView:
              swiper.querySelectorAll(".swiper-slide").length > 2
                ? 2.2
                : swiper.querySelectorAll(".swiper-slide").length,
            spaceBetween:
              swiper.dataset.spacebetween &&
              parseFloat(swiper.dataset.spacebetween) > 10
                ? parseFloat(swiper.dataset.spacebetween) - 10
                : 20,
          },
          1280: {
            slidesPerView:
              swiper.querySelectorAll(".swiper-slide").length > 3
                ? 3.2
                : swiper.querySelectorAll(".swiper-slide").length,
            spaceBetween:
              swiper.dataset.spacebetween &&
              parseFloat(swiper.dataset.spacebetween) > 5
                ? parseFloat(swiper.dataset.spacebetween) - 5
                : 25,
          },
          1536: {
            slidesPerView: swiper.dataset.slidesperview
              ? parseFloat(swiper.dataset.slidesperview)
              : "auto",
            spaceBetween: swiper.dataset.spacebetween
              ? parseFloat(swiper.dataset.spacebetween)
              : 30,
          },
        },
      };
      if (swiper.dataset.autoplay || swiper.dataset.autoplay === "0") {
        console.log("swiper.dataset.autoplay", swiper.dataset.autoplay);
        swiperOptions.autoplay = {
          delay: swiper.dataset.autoplay,
        };
        swiperOptions.loop = true;
        swiperOptions.freeMode = true;
        swiperOptions.speed = 8000;
      }
      var swiperElement = new Swiper(swiper, swiperOptions);
    });
  }

  // if (document.querySelectorAll(".slider-glide").length > 0) {
  //   let sliders = document.querySelectorAll(".slider-glide");
  //   for (const slider of sliders) {
  //     if (!(slider.dataset.destroymobile === "1" && width < 576)) {
  //       setTimeout(() => {
  //         slider.querySelector(".glide__slides").style.height =
  //           slider.offsetHeight + "px";
  //       }, 50);
  //       let glideSlider = new Glide(slider, {
  //         focusAt: 0,
  //         type: slider.dataset.typeslider
  //           ? slider.dataset.typeslider
  //           : "carousel",
  //         bound: slider.dataset.typeslider === "carousel" ? false : true,
  //         perView: slider.dataset.nbslidexxl ? slider.dataset.nbslidexxxl : "1",
  //         autoplay:
  //           slider.dataset.autoplay !== "0" ? slider.dataset.autoplay : false,
  //         hoverpause:
  //           slider.dataset.hoverpause && slider.dataset.hoverpause === "false"
  //             ? false
  //             : true,
  //         animationDuration: slider.dataset.animationduration
  //           ? slider.dataset.animationduration
  //           : 500,
  //         animationTimingFunc: "linear",
  //         gap: slider.dataset.gap ? slider.dataset.gap : 20,
  //         breakpoints: {
  //           1650: {
  //             perView: slider.dataset.nbslidexxl,
  //           },
  //           1399: {
  //             perView: slider.dataset.nbslidexl,
  //           },
  //           1199: {
  //             perView: slider.dataset.nbslidelg,
  //           },
  //           991: {
  //             perView: slider.dataset.nbslidemd,
  //             gap: 20,
  //           },
  //           767: {
  //             perView: slider.dataset.nbslidesm,
  //             gap: 20,
  //           },
  //           575: {
  //             perView: slider.dataset.nbslide,
  //             gap: 20,
  //           },
  //         },
  //       });
  //       if (!slider.dataset.noresize) {
  //         setTimeout(function (e) {
  //           glideHandleHeight(slider.dataset.id);
  //         }, 1000);
  //         glideSlider.on("run.after", function () {
  //           glideHandleHeight(slider.dataset.id);
  //         });
  //       }
  //       slider.addEventListener("mouseover", (e) => {
  //         glideSlider.pause();
  //       });
  //       slider.addEventListener("mouseout", (e) => {
  //         glideSlider.play();
  //       });
  //       glideSlider.mount();
  //     }
  //   }
  // }
});

// document.addEventListener("scroll", function () {
//   console.log("scroll");
//   console.log(window.scrollY);
//   console.log(document.querySelector(".js-fixed-left-part").offsetTop);
//   console.log(document.querySelector(".js-fixed-left-part").offsetHeight);
//   console.log(
//     window.scrollY >
//       document.querySelector(".js-fixed-left-part").offsetTop - 30 &&
//       window.scrollY +
//         document.querySelector(".js-fixed-left-part").offsetHeight +
//         50 <
//         document.querySelector(".footer").offsetTop
//   );
// });
